import React from 'react';
import LoginScreen from './LoginScreen';

const AuthWrapper: React.FC = () => {
  return <LoginScreen />;
};

export default AuthWrapper;